import { RouteObject } from'react-router-dom';
import { CreateReconnect } from './components/create/CreateReconnect';

export const reconnectRoutes: RouteObject[] = [
 {
 path:'create/reconnect',
 element: <CreateReconnect />,
 }
];
